import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Select, Widget } from '@spins/react-ui-library';
import { clientIdSelector } from 'store/global/selectors';

interface Props {
  children(clientId: string, type: string): React.ReactChild;
  defaultType: string;
  title: string;
  types: Array<string>;
}

const BaseChartWidget: React.FC<Props> = ({ children, defaultType, title, types }) => {
  const clientId: string = useSelector(clientIdSelector);
  const [type, setType] = useState(defaultType);
  return (
    <Widget>
      {{
        header: {
          title: `${type} ${title}`,
          content: {
            right: (
              <Select
                items={types.map((type) => ({ id: type, label: type }))}
                value={type}
                onSelect={(type) => setType(type)}
              />
            ),
          },
        },
        body: {
          content: children(clientId, type),
          style: { alignItems: 'center', display: 'flex', height: 460, justifyContent: 'center' },
        },
      }}
    </Widget>
  );
};

export default BaseChartWidget;
